import { ErrorSpan } from "@/components/ErrorSpan";
import { Item } from "../../queries/tracking-data/items";
import { PurchaseTaxCode } from "../../queries/tracking-data/vendor";

export const TaxCodeCell: React.FC<{ item: Item }> = ({ item }) => {
  const taxCodeMissing = !item.purchaseTaxCode;
  const taxCodeMismatch = item.preferredVendor?.taxCode && item.purchaseTaxCode?.id !== item.preferredVendor.taxCode.id;
  const error =
    taxCodeMissing ? "tax code is missing"
    : taxCodeMismatch ? "tax code does not match vendor"
    : null;
  return (
    <>
      {item.purchaseTaxCode ? formatPurchaseTaxCode(item.purchaseTaxCode) : ""}{" "}
      {error && <ErrorSpan>⚠ {error}</ErrorSpan>}
    </>
  );
};

export function formatPurchaseTaxCode(taxCode: NonNullable<PurchaseTaxCode>) {
  return `${taxCode.name} - ${taxCode.purchaseTaxRate.toLocaleString(undefined, { maximumFractionDigits: 5 })}%`;
}
